import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["results"];
import I18n from 'I18n';
import { UserTicketStatusOption, UserTicketViewOption } from './types';
import { DateFilterType, generateDateFilter } from '../constants/filters';
export const FAKE_THREAD_ID = 101;
export const FAKE_SECONDARY_THREAD_ID = 102;
export const PREVIEW_SINGLE_THREAD_TICKET_ID = 13;
export const PREVIEW_NO_THREAD_TICKET_ID = 14;
const PREVIEW_DEFAULT_LIMIT = 10;
const DEFAULT_THREAD_COUNT = 2;
const HOUR = 60 * 60 * 1000;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;
const MONTH = 30 * DAY;
const YEAR = 365 * DAY;
const buildPersonalTicketSeeds = () => [{
  id: 1,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectShort'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentShort'),
  age: 2 * HOUR,
  lastActivityAge: 2 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 2,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectMediumLong'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMediumLong'),
  age: 6 * HOUR,
  lastActivityAge: 6 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 3,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectWrapping'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentVeryLong'),
  age: 1 * DAY,
  lastActivityAge: 1 * DAY,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 4,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectTiny'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentTiny'),
  age: 2 * DAY,
  lastActivityAge: 2 * DAY,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 5,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectShort'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMedium'),
  age: 4 * DAY,
  lastActivityAge: 4 * DAY,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 6,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectLong'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMinimal'),
  age: 1 * WEEK,
  lastActivityAge: 2 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 7,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectConcise'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentLong'),
  age: 2 * WEEK,
  lastActivityAge: 1 * DAY,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 8,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectMedium'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentShort'),
  age: 3 * WEEK,
  lastActivityAge: 3 * WEEK,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 9,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectShort'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentLongAlt'),
  age: 1 * MONTH,
  lastActivityAge: 6 * HOUR,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 10,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectOverflow'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentCompact'),
  age: 6 * WEEK,
  lastActivityAge: 6 * WEEK,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 11,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectShort'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMinimal'),
  age: 2 * MONTH,
  lastActivityAge: 1 * WEEK,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 12,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectMediumLong'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentLong'),
  age: 3 * MONTH,
  lastActivityAge: 3 * MONTH,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: PREVIEW_SINGLE_THREAD_TICKET_ID,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectSingleThread'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMedium'),
  age: 5 * HOUR,
  lastActivityAge: 5 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary'),
  threadCount: 1
}, {
  id: PREVIEW_NO_THREAD_TICKET_ID,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectNoThreads'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentShort'),
  age: 8 * DAY,
  lastActivityAge: 8 * DAY,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary'),
  threadCount: 0
}];
const buildCompanyTicketSeeds = () => [{
  id: 1,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectConcise'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentLong'),
  age: 3 * HOUR,
  lastActivityAge: 3 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate1')
}, {
  id: 2,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectMedium'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMediumLong'),
  age: 12 * HOUR,
  lastActivityAge: 12 * HOUR,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate2')
}, {
  id: 3,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectTiny'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMinimal'),
  age: 1 * DAY,
  lastActivityAge: 1 * DAY,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 4,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectOverflow'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentVeryLong'),
  age: 3 * DAY,
  lastActivityAge: 2 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate3')
}, {
  id: 5,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectShort'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentCompact'),
  age: 5 * DAY,
  lastActivityAge: 5 * DAY,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate1')
}, {
  id: 6,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectWrapping'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMedium'),
  age: 10 * DAY,
  lastActivityAge: 1 * DAY,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate2')
}, {
  id: 7,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectMediumLong'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentShort'),
  age: 2 * WEEK,
  lastActivityAge: 2 * WEEK,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 8,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectLong'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentLongAlt'),
  age: 1 * MONTH,
  lastActivityAge: 12 * HOUR,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate3')
}, {
  id: 9,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectShort'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentTiny'),
  age: 6 * WEEK,
  lastActivityAge: 6 * WEEK,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate1')
}, {
  id: 10,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectMedium'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentLong'),
  age: 2 * MONTH,
  lastActivityAge: 2 * DAY,
  status: 'CLOSED',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate2')
}, {
  id: 11,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectConcise'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMinimal'),
  age: 4 * MONTH,
  lastActivityAge: 4 * MONTH,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary')
}, {
  id: 12,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectOverflow'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMediumLong'),
  age: 1 * YEAR,
  lastActivityAge: 1 * WEEK,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate3')
}, {
  id: PREVIEW_SINGLE_THREAD_TICKET_ID,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectSingleThread'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentMedium'),
  age: 5 * HOUR,
  lastActivityAge: 5 * HOUR,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary'),
  threadCount: 1
}, {
  id: PREVIEW_NO_THREAD_TICKET_ID,
  subject: I18n.text('customer-portal-app.inboxNavPanel.preview.subjectNoThreads'),
  content: I18n.text('customer-portal-app.inboxNavPanel.preview.contentShort'),
  age: 8 * DAY,
  lastActivityAge: 8 * DAY,
  status: 'OPEN',
  requester: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterTeammate1'),
  threadCount: 0
}];
const seedToTicket = (seed, now) => ({
  hs_ticket_id: seed.id,
  subject: seed.subject,
  content: seed.content,
  createdate: now - seed.age,
  hs_lastactivitydate: now - seed.lastActivityAge,
  status: seed.status,
  __requested_by_full_name_or_email: seed.requester
});
const cachedPreviewTickets = {};
const getPreviewTickets = view => {
  const cached = cachedPreviewTickets[view];
  if (cached) {
    return cached;
  }
  const now = Date.now();
  const seeds = view === UserTicketViewOption.COMPANY ? buildCompanyTicketSeeds() : buildPersonalTicketSeeds();
  const tickets = seeds.map(seed => seedToTicket(seed, now));
  cachedPreviewTickets[view] = tickets;
  return tickets;
};
let cachedThreadCountById = null;
const getThreadCountById = () => {
  if (cachedThreadCountById) {
    return cachedThreadCountById;
  }
  const map = new Map();
  [...buildPersonalTicketSeeds(), ...buildCompanyTicketSeeds()].forEach(seed => {
    if (seed.threadCount !== undefined) {
      map.set(seed.id, seed.threadCount);
    }
  });
  cachedThreadCountById = map;
  return map;
};
const isWithinRange = (value, range) => {
  if (!range) {
    return true;
  }
  if (typeof value !== 'number') {
    return false;
  }
  return value >= range.start && value <= range.end;
};
const compareValues = (a, b) => {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b;
  }
  return String(a !== null && a !== void 0 ? a : '').localeCompare(String(b !== null && b !== void 0 ? b : ''));
};
export function getPreviewTicketListings(variables = {}) {
  const {
    offset = 0,
    limit = PREVIEW_DEFAULT_LIMIT,
    ticketView = UserTicketViewOption.PERSONAL,
    statusFilter = UserTicketStatusOption.ALL,
    searchString = '',
    sort = ['-createdate'],
    createDateFilter = DateFilterType.ALL_TIME,
    lastActivityFilter = DateFilterType.ALL_TIME
  } = variables;
  const createRange = generateDateFilter('createdate', createDateFilter);
  const lastActivityRange = generateDateFilter('hs_lastactivitydate', lastActivityFilter);
  const normalizedSearch = searchString.trim().toLowerCase();
  const filtered = getPreviewTickets(ticketView).filter(ticket => {
    if (statusFilter !== UserTicketStatusOption.ALL && ticket.status !== statusFilter) {
      return false;
    }
    if (normalizedSearch) {
      var _ticket$subject, _ticket$content;
      const haystack = `${ticket.hs_ticket_id} ${(_ticket$subject = ticket.subject) !== null && _ticket$subject !== void 0 ? _ticket$subject : ''} ${(_ticket$content = ticket.content) !== null && _ticket$content !== void 0 ? _ticket$content : ''}`.toLowerCase();
      if (!haystack.includes(normalizedSearch)) {
        return false;
      }
    }
    if (!isWithinRange(ticket.createdate, createRange)) {
      return false;
    }
    if (!isWithinRange(ticket.hs_lastactivitydate, lastActivityRange)) {
      return false;
    }
    return true;
  });
  const [sortToken = '-createdate'] = sort;
  const descending = sortToken.startsWith('-');
  const sortField = descending ? sortToken.slice(1) : sortToken;
  const sorted = [...filtered].sort((a, b) => {
    const result = compareValues(a[sortField], b[sortField]);
    return descending ? -result : result;
  });
  const results = sorted.slice(offset, offset + limit);
  return {
    total: sorted.length,
    hasMore: offset + limit < sorted.length,
    offset,
    results
  };
}
export function getPreviewNavigationTickets(variables = {}) {
  const _getPreviewTicketList = getPreviewTicketListings(variables),
    {
      results
    } = _getPreviewTicketList,
    rest = _objectWithoutPropertiesLoose(_getPreviewTicketList, _excluded);
  return Object.assign({}, rest, {
    results: results.map(ticket => {
      var _ref, _ref2, _ref3, _ref4;
      return {
        ticketId: ticket.hs_ticket_id,
        subject: (_ref = ticket.subject) !== null && _ref !== void 0 ? _ref : null,
        content: (_ref2 = ticket.content) !== null && _ref2 !== void 0 ? _ref2 : null,
        requestedBy: (_ref3 = ticket.__requested_by_full_name_or_email) !== null && _ref3 !== void 0 ? _ref3 : null,
        createDate: (_ref4 = ticket.createdate) !== null && _ref4 !== void 0 ? _ref4 : null,
        isClosed: ticket.status === 'CLOSED'
      };
    })
  });
}
const PLACEHOLDER_TIMESTAMP = Date.now() - 3 * DAY;
const PLACEHOLDER_DURATION = 2 * HOUR;
const getPlaceholderForType = (crmPropertyType, numberDisplayHint) => {
  switch (crmPropertyType) {
    case 'date':
    case 'datetime':
      return PLACEHOLDER_TIMESTAMP;
    case 'number':
      return numberDisplayHint === 'duration' ? PLACEHOLDER_DURATION : 42;
    case 'enumeration':
      return I18n.text('customer-portal-app.inboxNavPanel.preview.placeholderEnum');
    default:
      return I18n.text('customer-portal-app.inboxNavPanel.preview.placeholderText');
  }
};
export const augmentTicketWithPlaceholders = (ticket, configuredProperties) => {
  const result = Object.assign({}, ticket);
  for (const {
    propertyName,
    crmPropertyType,
    numberDisplayHint
  } of configuredProperties) {
    if (result[propertyName] != null) continue;
    result[propertyName] = getPlaceholderForType(crmPropertyType, numberDisplayHint);
  }
  return result;
};
export function getPreviewTicket(id) {
  const ticket = getPreviewTickets(UserTicketViewOption.PERSONAL).find(t => t.hs_ticket_id === id);
  return ticket !== null && ticket !== void 0 ? ticket : {
    hs_ticket_id: id
  };
}
const PREVIEW_CUSTOMER_ACTOR = 'PREVIEW_CUSTOMER';
const PREVIEW_AGENT_ACTOR = 'PREVIEW_AGENT';
const PREVIEW_ATTACHMENT_ID = 'PREVIEW_ATTACHMENT_1';
const makeActorSender = actorId => ({
  actorId,
  type: 'ACTOR_ID'
});
const buildPreviewAttachment = now => ({
  fileMetadata: {
    expiresAt: now + 24 * HOUR,
    url: '#preview-attachment',
    extension: 'pdf',
    name: I18n.text('customer-portal-app.inboxNavPanel.preview.threadAttachmentName'),
    size: 102400,
    type: 'application/pdf'
  },
  attachmentTimestamp: now - 2 * DAY
});
export function getPreviewTicketThread() {
  const now = Date.now();
  const customerSender = makeActorSender(PREVIEW_CUSTOMER_ACTOR);
  const agentSender = makeActorSender(PREVIEW_AGENT_ACTOR);
  const messages = [{
    id: 'PREVIEW_MSG_1',
    '@type': 'MESSAGE',
    timestamp: now - 3 * DAY,
    sender: customerSender,
    richText: I18n.text('customer-portal-app.inboxNavPanel.preview.threadInitialMessage')
  }, {
    id: 'PREVIEW_MSG_2',
    '@type': 'MESSAGE',
    timestamp: now - 3 * DAY + 3 * HOUR,
    sender: agentSender,
    richText: I18n.text('customer-portal-app.inboxNavPanel.preview.threadAgentReply1')
  }, {
    id: 'PREVIEW_MSG_3',
    '@type': 'MESSAGE',
    timestamp: now - 1 * DAY,
    sender: customerSender,
    richText: I18n.text('customer-portal-app.inboxNavPanel.preview.threadCustomerFollowUp'),
    attachments: [{
      '@type': 'FILES',
      fileIds: [PREVIEW_ATTACHMENT_ID]
    }]
  }, {
    id: 'PREVIEW_MSG_4',
    '@type': 'MESSAGE',
    timestamp: now - 1 * DAY + 4 * HOUR,
    sender: agentSender,
    richText: I18n.text('customer-portal-app.inboxNavPanel.preview.threadAgentReply2')
  }];
  return {
    attachmentsMap: {
      [PREVIEW_ATTACHMENT_ID]: buildPreviewAttachment(now)
    },
    sensitiveAttachmentsMetadata: {},
    responders: {
      [JSON.stringify(customerSender)]: {
        displayName: I18n.text('customer-portal-app.inboxNavPanel.preview.requesterPrimary'),
        avatar: null
      },
      [JSON.stringify(agentSender)]: {
        displayName: I18n.text('customer-portal-app.inboxNavPanel.preview.agentName'),
        avatar: null
      }
    },
    recipients: {},
    pagedThreadHistory: {
      results: messages,
      hasMore: false,
      offset: {
        timestamp: messages[0].timestamp,
        ordinal: 0
      }
    }
  };
}
export function getPreviewThreadAttachments() {
  const now = Date.now();
  return {
    attachments: [buildPreviewAttachment(now)],
    sensitiveAttachments: []
  };
}
export function getPreviewTicketThreads(ticketId) {
  var _getThreadCountById$g;
  const now = Date.now();
  const threadCount = ticketId === undefined ? DEFAULT_THREAD_COUNT : (_getThreadCountById$g = getThreadCountById().get(ticketId)) !== null && _getThreadCountById$g !== void 0 ? _getThreadCountById$g : DEFAULT_THREAD_COUNT;
  const allThreads = [{
    threadId: FAKE_THREAD_ID,
    startedAt: now - 2 * HOUR,
    latestMessageTimestamp: now - 2 * HOUR,
    originalChannel: 'EMAIL'
  }, {
    threadId: FAKE_SECONDARY_THREAD_ID,
    startedAt: now - 3 * DAY,
    latestMessageTimestamp: now - 2 * DAY,
    originalChannel: 'FORMS'
  }];
  return {
    threads: allThreads.slice(0, threadCount)
  };
}